import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { resetFirstLastMargins } from '@/css/resources/placeholders.css';
import { transitions } from '@/css/resources/variables.css';
import {
	expandLink,
	fontStyle,
	fluidValues,
	fluidPadding,
	fluidBorderWidth,
	fluidBorderRadius,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidPadding(styles?.padding),
		fluidBorderWidth(styles?.border?.width),
		fluidBorderRadius(styles?.border?.radius),
		{
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,
			background: styles?.backgroundColor,
			borderColor: styles?.border?.color,

			'.supt-cardKeyfact__imageWrapper': {
				justifyContent: styles?.image?.alignment,
			},

			'.supt-cardKeyfact__image': {
				'.supt-figure__image': fluidBorderRadius(
					styles?.image?.border?.radius
				),

				/* stylelint-disable-next-line */
				img: fluidValues(
					'maxHeight',
					styles?.image?.height?.[0],
					styles?.image?.height?.[1],
					true
				),
			},

			'.supt-cardKeyfact__label': fontStyle({
				...styles?.label?.typography,
				textAlign: styles?.label?.textAlignment,
				color: styles?.label?.color,
			}),
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		borderStyle: 'solid',

		'.supt-cardKeyfact__imageWrapper': {
			display: 'flex',
		},

		'.supt-cardKeyfact__image': {
			display: 'inline-flex',
		},

		'.supt-cardKeyfact__label': cssObj(resetFirstLastMargins, {
			display: 'block',
			'&.supt-cardKeyfact__link': {
				textDecoration: 'none',
			},
		}),

		/* with link */
		'&.supt-withLink': cssObj(expandLink(), {
			transition: `all ${transitions.mid} ease-out`,

			'.supt-cardKeyfact__label': {
				transition: `all ${transitions.mid} ease-out`,
			},

			'&:hover, &:focus-within': getDynamicStyles(styles?.states?.hover),
		}),
	});

// edit
const getEditGlobalStyles = (styles) =>
	cssObj({
		'.wp-block[data-type="supt/card-keyfact-icon"]': {
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,

			'.supt-card': {
				height: '100%',
			},

			'.supt-cardKeyfact__image': {
				display: 'flex',
				width: '50%',

				figure: {
					width: '100%',
				},
			},

			'.editor-post-featured-image__preview img': {
				objectFit: 'contain',
				height: '100%',
				width: '100%',
			},

			p: {
				marginRight: '0px',
				marginLeft: '0px',

				'&:first-child': {
					marginTop: '0px',
				},
			},
		},
	});

export { getStyles, getEditGlobalStyles };
